import React from "react";
import FormCreateRoom from "./FormCreateRoom.js";
import { ClientColyseusContext } from "../../contexts/ClientColyseusContext.js";
import Button from "../Button.js";
import { withRouter } from "react-router-dom";

class PageMultiplayer extends React.Component {
  static contextType = ClientColyseusContext;

  constructor(props) {
    super(props);
    this.state = {
      refreshRoom: {},
    };
  }

  componentDidMount() {
    console.log(this.context);
    this.context.getAvailableRooms();
    this.setState({
      refreshRoom: setInterval(() => {
        this.context.getAvailableRooms();
      }, 60000),
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.refreshRoom);
  }

  render() {
    return (
      <ClientColyseusContext.Consumer>
        {(contextClientColyseus) => {
        return (
          <div className="mt-5" style={{ marginTop: "100px"}}>
            <FormCreateRoom />
            <div className="row justify-content-center"> {/* This row with justify-content-center centers the child column */}
              <div className="col-md-8"> {/* This column is set to 8 out of 12, which is medium-sized */}
                <div className="table-responsive" style={{ marginTop: "50px"}}>
                  <table className="table table-striped table-hover mx-auto"> {/* mx-auto centers the table */}
                    <thead className="thead-dark">
                      <tr>
                        <th>Id</th>
                        <th>Mode</th>
                        <th>Course</th>
                        <th>Join</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contextClientColyseus.roomsList.map((room, index) => (
                        <tr key={index}>
                          <td>{room.roomId}</td>
                          <td>{room.name}</td>
                          <td>{room.metadata.course}</td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                contextClientColyseus.joinById(room.roomId);
                                this.props.history.push({
                                  pathname: `/lobby/${room.roomId}`,
                                  state: {
                                    pwd: this.state.pwd,
                                    name: this.state.name,
                                    course: this.state.course,
                                  },
                                });
                              }}
                            >
                              Join
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        );
        
        }}
      </ClientColyseusContext.Consumer>
    );
  }
}

export default withRouter(PageMultiplayer); // Wrap the export


